var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.hasTeam
    ? _c("div", { staticClass: "md-layout" }, [
        _c(
          "div",
          {
            staticClass:
              "md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100",
          },
          [
            _c("div", { staticClass: "custom-toolbar" }, [
              _c(
                "div",
                { staticClass: "custom-toolbar-start" },
                [
                  _c(
                    "router-link",
                    { attrs: { to: { name: "Team Settings" } } },
                    [
                      _c("h3", { staticClass: "title" }, [
                        _vm._v("Team Settings"),
                      ]),
                    ]
                  ),
                  _c("h3", { staticClass: "title" }, [
                    _vm._v("   >    Run Sheet"),
                  ]),
                ],
                1
              ),
            ]),
          ]
        ),
        _c(
          "div",
          { staticClass: "md-layout-item md-size-100" },
          [
            _c(
              "md-card",
              [
                _c(
                  "md-card-header",
                  { staticClass: "md-card-header-icon md-card-header-blue" },
                  [
                    _c(
                      "div",
                      { staticClass: "card-icon" },
                      [_c("md-icon", [_vm._v("description")])],
                      1
                    ),
                  ]
                ),
                _c("md-card-content", [
                  _c("h5", { staticClass: "card-title" }, [_vm._v("Settings")]),
                  _c("div", { staticClass: "md-layout" }, [
                    _c(
                      "div",
                      { staticClass: "md-layout-item md-size-100 layout-item" },
                      [
                        _c(
                          "md-checkbox",
                          {
                            attrs: { disabled: _vm.isSaving },
                            model: {
                              value: _vm.includeBarcodes,
                              callback: function ($$v) {
                                _vm.includeBarcodes = $$v
                              },
                              expression: "includeBarcodes",
                            },
                          },
                          [
                            _vm._v(
                              "\n                            Include item barcodes on runsheet\n                        "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                ]),
                _c("md-card-actions", { attrs: { "md-alignment": "left" } }, [
                  _c(
                    "button",
                    {
                      staticClass: "custom-btn",
                      attrs: { disabled: _vm.isSaving },
                      on: { click: _vm.save },
                    },
                    [_vm._v("Save")]
                  ),
                ]),
              ],
              1
            ),
          ],
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }